<template>
    <div id="itemPrice">

        <!--Titre-->
        <b-row align-v="center">
            <b-col class="aRight" :cols="prixSize.reg" :xl="prixSize.xl"></b-col>
            <b-col class="MargeLeft15 TxInTxOut" cols=4><b-row>{{$t('i_Avtx')}}</b-row></b-col>
            <b-col class="TxInTxOut" cols=4><b-row>{{$t('i_Txin')}}</b-row></b-col>
        </b-row> 

        <!--Coutant-->
        <b-row align-v="center">
            <b-col class="aRight" :cols="prixSize.reg" :xl="prixSize.xl">
                <span class="txtSign">{{$t('i_Coutant')}}</span>
            </b-col>
            <b-col :cols="prixSize.price">
                <b-row align-v="center">
                    <s-currencyInput class="Prix" append="$" :decimal="priceDecimal" v-model="txtCost"></s-currencyInput>
                </b-row>
            </b-col>
            <b-col :cols="prixSize.price">
                <b-row align-v="center">
                    <s-currencyInput class="Prix" append="$" :decimal="priceDecimal" v-model="txtCost"></s-currencyInput>
                </b-row>
            </b-col>
        </b-row>

        <div class="splitSpace"/>

        <!--Prix 1-->
        <b-row align-v="center">
            <b-col class="aRight" :cols="prixSize.reg" :xl="prixSize.xl">
                <span class="txtSign">{{$t('i_Price1')}}</span>
            </b-col>
            <b-col :cols="prixSize.price">
                <b-row align-v="center">
                    <s-currencyInput class="Prix" append="$" :decimal="priceDecimal" v-model="txtPrice1"></s-currencyInput>
                </b-row>
            </b-col>
            <b-col :cols="prixSize.price">
                <b-row align-v="center">
                    <s-currencyInput class="Prix" append="$" :decimal="priceDecimal" v-model="txtPrice1"></s-currencyInput>
                </b-row>
            </b-col>
        </b-row>
        <!--Prix 2-->
        <b-row align-v="center">
            <b-col class="aRight" :cols="prixSize.reg" :xl="prixSize.xl">
                <span class="txtSign">{{$t('i_Price2')}}</span>
            </b-col>
            <b-col :cols="prixSize.price">
                <b-row align-v="center">
                    <s-currencyInput class="Prix" append="$" :decimal="priceDecimal" v-model="txtPrice2"></s-currencyInput>
                </b-row>
            </b-col>
            <b-col :cols="prixSize.price">
                <b-row align-v="center">
                    <s-currencyInput class="Prix" append="$" :decimal="priceDecimal" v-model="txtPrice2"></s-currencyInput>
                </b-row>
            </b-col>
        </b-row>
        <!--Prix 3-->
        <b-row align-v="center">
            <b-col class="aRight" :cols="prixSize.reg" :xl="prixSize.xl">
                <span class="txtSign">{{$t('i_Price3')}}</span>
            </b-col>
            <b-col :cols="prixSize.price">
                <b-row align-v="center">
                    <s-currencyInput class="Prix" append="$" :decimal="priceDecimal" v-model="txtPrice3"></s-currencyInput>
                </b-row>
            </b-col>
            <b-col :cols="prixSize.price">
                <b-row align-v="center">
                    <s-currencyInput class="Prix" append="$" :decimal="priceDecimal" v-model="txtPrice3"></s-currencyInput>
                </b-row>
            </b-col>
        </b-row>
        <!--Prix 4-->
        <b-row align-v="center">
            <b-col class="aRight" :cols="prixSize.reg" :xl="prixSize.xl">
                <span class="txtSign">{{$t('i_Price4')}}</span>
            </b-col>
            <b-col :cols="prixSize.price">
                <b-row align-v="center">
                    <s-currencyInput class="Prix" append="$" :decimal="priceDecimal" v-model="txtPrice4"></s-currencyInput>
                </b-row>
            </b-col>
            <b-col :cols="prixSize.price">
                <b-row align-v="center">
                    <s-currencyInput class="Prix" append="$" :decimal="priceDecimal" v-model="txtPrice4"></s-currencyInput>
                </b-row>
            </b-col>
        </b-row>

        <div class="splitSpace"/>

        <!--Deposite / Consigne -->
        <b-row align-v="center">
            <b-col class="aRight" :cols="prixSize.reg" :xl="prixSize.xl">
                <span class="txtSign">{{$t('i_Consigne')}}</span>
            </b-col>
            <b-col :cols="prixSize.price">
                <b-row align-v="center">
                    <s-currencyInput class="Prix" append="$" v-model="txtConsigne"></s-currencyInput>
                </b-row>
            </b-col>
        </b-row>

        <!--Groupe de prix-->
        <b-row align-v="center">
            <b-col :cols="prixSize.reg" :xl="prixSize.xl"></b-col>
            <b-col :cols="prixSize.price * 2 ">
                    <s-subElementSelector 
                        class="grpPrix" 
                        saveValue="groupName"
                        :apiAdd1="this.$store.getters.getApiAdress + this.$store.getters.getApiAdd.magasin.apiItemPriceGroup" 
                        showField="groupName" 
                        returnField="id" 
                        :content="grpPrixList"
                        :returnAddValue.sync="grpPrixList"
                        name= "GroupeDePrix" 
                        addLength="30"
                        :title="$t('i_GroupeDePrix')" 
                        :value="_PriceGroupId" 
                        :returnValue.sync="_PriceGroupId" 
                        :selectedItems="_PriceGroupId">
                    </s-subElementSelector>
            </b-col>
        </b-row>

    </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default{
    name: 'itemPrice',
    components: {

    },
    props: ['prixSize', 'priceDecimal', 'cost', 'itemprice1', 
            'itemprice2', 'itemprice3', 'itemprice4', 'deposite', 'priceGroupId'],
    data() {
        return {

        }
    },
    methods: {

    },
    computed: {
        ...mapGetters(['getTheme', 'getApiAdress']),
        txtCost: {
            get: function() {return this.cost},
            set: function(modifiedValue){this.$emit('update:cost', modifiedValue)}
        },
        txtPrice1: {
            get: function() {return this.itemprice1},
            set: function(modifiedValue){this.$emit('update:itemprice1', modifiedValue)}
        },
        txtPrice2: {
            get: function() {return this.itemprice2},
            set: function(modifiedValue){this.$emit('update:itemprice2', modifiedValue)}
        },
        txtPrice3: {
            get: function() {return this.itemprice3},
            set: function(modifiedValue){this.$emit('update:itemprice3', modifiedValue)}
        },
        txtPrice4: {
            get: function() {return this.itemprice4},
            set: function(modifiedValue){this.$emit('update:itemprice4', modifiedValue)}
        },
        txtConsigne: {
            get: function() {return this.deposite},
            set: function(modifiedValue){this.$emit('update:deposite', modifiedValue)}
        },
        _PriceGroupId: {
            get: function() {return this.priceGroupId},
            set: function(modifiedValue){this.$emit('update:priceGroupId', modifiedValue)}
        },
        /**
         * Retourne la liste des groupes de prix
         */
         grpPrixList() {
            return this.$store.getters.getInventory.data.itemPriceGroupList;
        },
    }    
}
</script>

<style lang="scss" scoped>

</style>